import { BaseEntity, Column, Entity, Index, JoinColumn, JoinTable, ManyToMany, ManyToOne, OneToMany, OneToOne, PrimaryColumn, PrimaryGeneratedColumn, RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn } from "typeorm";
import { ProductionInventory } from "../operations-track/entities/production-inventory.entity";
import { ProductionLog } from "../operations-track/entities/production-log.entity";
import { WorkstationCategories } from "../workstation-category/workstation-category.entity";
@Entity('workstations')
export class WorkStations {

  @PrimaryGeneratedColumn("increment", { name: 'workstation_id' })
  workstationId: number;


  @Column("varchar", {
    nullable: false,
    length: 40,
    name: "workstation"
  })
  workstation: string;
  @Column("varchar", {
    // nullable: false,
    length: 40,
    name: "workstation_code"
  })
  workstationCode:string;
  
  @Column("varchar", {
    nullable: false,
    length: 40,
    name: "workstation_unit_capacity"
  })
  workstationUnitCapacity: number;

  @Column("int",{
    nullable:false,
    name:"workstation_category_id"
    })
    workstationCategoryId:number;

  @Column("int", {
    nullable: true,
    name: "unit_id"
  })
  unitId: number;


 
  @Column("boolean", {
    nullable: false,
    default: true,
    name: "is_active"
  })
  isActive: boolean;
  @CreateDateColumn({
    name: "created_at",
    type: "datetime"
  })
  createdAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "created_user"
  })
  createdUser: string | null;


  @UpdateDateColumn({
    name: "updated_at",
    type: 'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "updated_user"
  })
  updatedUser: string | null;


  @VersionColumn({
    default: 1,
    name: "version_flag"
  })
  versionFlag: number;


  @ManyToOne(type => WorkstationCategories, workstationCategory => workstationCategory.workstationInfo, { nullable: false, })
  @JoinColumn({ name: "workstation_category_id" })
  workstationCategoryInfo: WorkstationCategories;

  @OneToMany(type => ProductionLog, log => log.workstation, {cascade: true})
  productionLog: ProductionLog[];
 
}